// extracted by mini-css-extract-plugin
module.exports = {"card":"p_c","red":"p_t","blue":"p_v","green":"p_w","yellow":"p_x","orange":"p_y","violet":"p_z","title":"p_r"};